/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { vendaApi } from '../../services';
import useForm from '../useForm';
import Alert from '../../helpers/Alert';
import { useNavigate } from 'react-router-dom';
import { z } from 'zod';
import { Venda } from '../../models';
import { useVendasCategorias } from '../useVendasCategorias';

const rules = z.object({
  nome: z.string().min(1),
  valor: z.string().min(1),
  descricao: z.string().min(1),
  categoria_id: z.number().min(1),
  data: z.string().min('XXXX-XX-XX'.length),
  pagamento_forma: z.string().min(1),
});

export type UseVendaForm = {
  id?: number | string;
}

type FormType = Venda & {
};

export function useVendaForm(props?: UseVendaForm) {
  const navigate = useNavigate();
  const { categorias, categoriasAsSelectOptions } = useVendasCategorias();

  const { form, setForm, errors, register, setLoading, loading, validateWithZod } = useForm<FormType>({
    loader: vendaApi.one as any,
  });

  useEffect(() => {
    props?.id ? load(props?.id) : setForm({});
  }, [props?.id]);

  async function save() {
    if (!validateWithZod(rules)) return;
    setLoading(true);
    const response = await vendaApi.save(form);
    setLoading(false);
    if (response.isError) {
        return Alert.error(response.data.message || 'Falha ao salvar venda');
    }
    Alert.success('Venda salva com sucesso');
    navigate(0);
  }

  async function load(id: number | string) {
    setLoading(true);
    const { data, isError } = await vendaApi.one(id as any);
    setLoading(false);
    if (isError) {
      return Alert.error(data.message || 'Falha ao carregar aluno');
    }
    setForm(data);
  }

  return {
    form,
    setForm,
    save,
    loading,
    errors, 
    register,
    load,
    formaPagamento: {
      asSelectOptions: [
        {value: 'Pix',      label: 'Pix'},
        {value: 'Boleto',   label: 'Boleto'},
        {value: 'Cartão',   label: 'Cartão'},
        {value: 'Dinheiro', label: 'Dinheiro'},
      ],
    },
    categorias: {
      data: categorias,
      asSelectOptions: categoriasAsSelectOptions
    }
  }
}
